!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.ReactSpeedyReader = t(require("react")) : e.ReactSpeedyReader = t(e.React);
}(window, function (__WEBPACK_EXTERNAL_MODULE__2__) {
  return function (e) {
    var t = {};
    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }
    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "/", r(r.s = 6);
  }([function (e, t, r) {
    "use strict";

    e.exports = r(3);
  }, function (e, t, r) {
    e.exports = r(9)();
  }, function (e, t) {
    e.exports = __WEBPACK_EXTERNAL_MODULE__2__;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = function (e) {
        return e && "object" == typeof e && "default" in e ? e.default : e;
      }(r(2)),
      o = function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      },
      i = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      },
      a = function (e) {
        function t() {
          return o(this, t), i(this, e.apply(this, arguments));
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, e), t.prototype.render = function () {
          return n.Children.only(this.props.children);
        }, t;
      }(n.Component);
    t.AppContainer = a, t.hot = function () {
      return function (e) {
        return e;
      };
    }, t.areComponentsEqual = function (e, t) {
      return e === t;
    }, t.setConfig = function () {}, t.cold = function (e) {
      return e;
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (!e.webpackPolyfill) {
        var t = Object.create(e);
        t.children || (t.children = []), Object.defineProperty(t, "loaded", {
          enumerable: !0,
          get: function () {
            return t.l;
          }
        }), Object.defineProperty(t, "id", {
          enumerable: !0,
          get: function () {
            return t.i;
          }
        }), Object.defineProperty(t, "exports", {
          enumerable: !0
        }), t.webpackPolyfill = 1;
      }
      return t;
    };
  }, function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    (function (module) {
      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2),
        react__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__),
        prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1),
        prop_types__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
      function _typeof(e) {
        return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function _objectSpread(e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {},
            n = Object.keys(r);
          "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
          }))), n.forEach(function (t) {
            _defineProperty(e, t, r[t]);
          });
        }
        return e;
      }
      function _classCallCheck(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }
      function _createClass(e, t, r) {
        return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
      }
      function _possibleConstructorReturn(e, t) {
        return !t || "object" !== _typeof(t) && "function" != typeof t ? _assertThisInitialized(e) : t;
      }
      function _assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }
      function _getPrototypeOf(e) {
        return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      function _inherits(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && _setPrototypeOf(e, t);
      }
      function _setPrototypeOf(e, t) {
        return (_setPrototypeOf = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      function _defineProperty(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r, e;
      }
      !function () {
        var e = __webpack_require__(0).enterModule;
        e && e(module);
      }();
      var MILLISECONDS_IN_MINUTE = 6e4,
        WHITESPACE_SEPARATOR = " ",
        SpeedyReader = function (_Component) {
          function SpeedyReader(e) {
            var t;
            return _classCallCheck(this, SpeedyReader), (t = _possibleConstructorReturn(this, _getPrototypeOf(SpeedyReader).call(this, e))).state = t.getInitialState(), t.timer = null, t;
          }
          return _inherits(SpeedyReader, _Component), _createClass(SpeedyReader, [{
            key: "getInitialState",
            value: function () {
              var e = this.props,
                t = e.autoPlay,
                r = e.inputText;
              return {
                currentPosition: 0,
                currentText: "",
                isPlaying: t,
                words: this.getWords(r)
              };
            }
          }, {
            key: "componentDidMount",
            value: function () {
              this.props.autoPlay && this.play();
            }
          }, {
            key: "componentWillReceiveProps",
            value: function (e) {
              var t = this.props,
                r = t.speed,
                n = t.wordChunk;
              this.state.isPlaying && (e.speed !== r || e.wordChunk !== n) && this.update();
            }
          }, {
            key: "componentWillUnmount",
            value: function () {
              this.timer && clearTimeout(this.timer);
            }
          }, {
            key: "getWords",
            value: function (e) {
              return e ? e.split(/\s+/g).filter(Boolean) : [];
            }
          }, {
            key: "pause",
            value: function () {
              var e = this;
              this.setState({
                isPlaying: !1
              }, function () {
                return e.update();
              });
            }
          }, {
            key: "play",
            value: function () {
              var e = this;
              this.setState({
                isPlaying: !0
              }, function () {
                return e.update();
              });
            }
          }, {
            key: "reset",
            value: function () {
              var e = this,
                t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
              this.setState(_objectSpread({}, this.getInitialState(), {
                isPlaying: t
              }), function () {
                return e.update();
              });
            }
          }, {
            key: "update",
            value: function () {
              var e = this;
              if (this.timer && clearTimeout(this.timer), this.state.isPlaying) {
                var t = this.props,
                  r = t.speed,
                  n = t.wordChunk,
                  o = t.onFinish,
                  i = MILLISECONDS_IN_MINUTE / r;
                this.timer = setTimeout(function () {
                  var t = e.state.currentPosition,
                    r = e.state.words,
                    a = r.length;
                  t += n;
                  var u = n >= a - 1 ? 0 : t - n,
                    _ = r.slice(u, t).join(WHITESPACE_SEPARATOR);
                  e.setState({
                    currentPosition: t,
                    currentText: _
                  }, function () {
                    (u += n) < a ? e.update() : e.timer = setTimeout(function () {
                      e.setState({
                        isPlaying: !1
                      }, function () {
                        o && o();
                      });
                    }, i);
                  });
                }, i);
              }
            }
          }, {
            key: "render",
            value: function () {
              var e = this.state.currentText;
              return e ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", null, e) : react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", null, " ");
            }
          }, {
            key: "__reactstandin__regenerateByEval",
            value: function __reactstandin__regenerateByEval(key, code) {
              this[key] = eval(code);
            }
          }]), SpeedyReader;
        }(react__WEBPACK_IMPORTED_MODULE_0__.Component);
      _defineProperty(SpeedyReader, "defaultProps", {
        autoPlay: !1,
        onFinish: void 0,
        speed: 250,
        wordChunk: 1
      }), _defineProperty(SpeedyReader, "propTypes", {
        autoPlay: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
        inputText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,
        onFinish: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        speed: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        wordChunk: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number
      });
      var _default = SpeedyReader;
      __webpack_exports__.a = _default, function () {
        var e = __webpack_require__(0).default,
          t = __webpack_require__(0).leaveModule;
        e && (e.register(MILLISECONDS_IN_MINUTE, "MILLISECONDS_IN_MINUTE", "/home/travis/build/deadlybyte/react-speedy-reader/src/SpeedyReader.js"), e.register(WHITESPACE_SEPARATOR, "WHITESPACE_SEPARATOR", "/home/travis/build/deadlybyte/react-speedy-reader/src/SpeedyReader.js"), e.register(SpeedyReader, "SpeedyReader", "/home/travis/build/deadlybyte/react-speedy-reader/src/SpeedyReader.js"), e.register(_default, "default", "/home/travis/build/deadlybyte/react-speedy-reader/src/SpeedyReader.js"), t(module));
      }();
    }).call(this, __webpack_require__(4)(module));
  }, function (e, t, r) {
    r(7), e.exports = r(8);
  }, function (e, t, r) {
    "use strict";

    e.exports = r(3);
  }, function (e, t, r) {
    "use strict";

    r.r(t), function (e) {
      var n = r(5);
      !function () {
        var t = r(0).enterModule;
        t && t(e);
      }();
      var o = n.a;
      t.default = o, function () {
        var t = r(0).default,
          n = r(0).leaveModule;
        t && (t.register(o, "default", "/home/travis/build/deadlybyte/react-speedy-reader/src/index.js"), n(e));
      }();
    }.call(this, r(4)(e));
  }, function (e, t, r) {
    "use strict";

    var n = r(10);
    function o() {}
    e.exports = function () {
      function e(e, t, r, o, i, a) {
        if (a !== n) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }
      function t() {
        return e;
      }
      e.isRequired = e;
      var r = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return r.checkPropTypes = o, r.PropTypes = r, r;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }]);
});